import { STATUS, STATUS_KEY } from "@/app/ui/views/login/constants";

export class AuthEntities {
  token = "";
  type = "";
  expiredAt = "";
  constructor(fields?: Partial<AuthEntities>) {
    Object.assign(this, fields);
  }
}

export class DeviceAuthEntities {
  needApproval = false as boolean;
  approval = new AuthEntities();
  login = new AuthEntities();
  pairingCode = "";
  constructor(fields?: Partial<DeviceAuthEntities>) {
    Object.assign(this, fields);
  }
}

export class DeviceAuthCheckApprovalEntities {
  status = "" as typeof STATUS[STATUS_KEY];
  masterPhoneNumber = "" as string;
  login = new AuthEntities();
  device = { token: "" };
  constructor(fields?: Partial<DeviceAuthCheckApprovalEntities>) {
    Object.assign(this, fields);
  }
}

export class TokenVerificationAccountEntities {
  token = "";
  emailUser = "";
  phoneUser = "";
  emailPartnerClient = "";
  phoneNumberPartnerClient = "";
  password = "";
  action = "";
  constructor(fields?: Partial<TokenVerificationAccountEntities>) {
    Object.assign(this, fields);
  }
}

export class Credential {
  username = "";
  email = "";
  password = "";
  constructor(fields?: Partial<Credential>) {
    Object.assign(this, fields);
  }
}

export class EnrollmentEntity {
  enrolled = false;
  setupRequired = false;
  constructor(fields?: Partial<EnrollmentEntity>) {
    Object.assign(this, fields);
  }
}

export class TwoFactorAuthEntity {
  otpRequired = false;
  challengeToken = "";
  expiresAt = "";
  enrollment = new EnrollmentEntity();
  constructor(fields?: Partial<TwoFactorAuthEntity>) {
    Object.assign(this, fields);
  }
}

export class Login2faEntity {
  authentication = new AuthEntities();
  twoFactorAuthentication = new TwoFactorAuthEntity();
  constructor(fields?: Partial<Login2faEntity>) {
    Object.assign(this, fields);
  }
}

export class OtpRequestResponseEntity {
  token = "";
  otpExpiresInSeconds = 0;
  expiresAt = "";
  maskedEmail = "";
  isResend = false;
  otpRegenerated = false;
  resendAvailableAfterSeconds = 0;
  resendAvailableAt = "";

  constructor(fields?: Partial<OtpRequestResponseEntity>) {
    Object.assign(this, fields);
  }
}

export class SetupPasswordValidation {
  success = false;
  code = 0;
  email = "";
  token = "";
  isValid = false;
  isExpired = false;
  isUsed = false;
  isInvalid = false;
  constructor(fields?: Partial<SetupPasswordValidation>) {
    Object.assign(this, fields);

    if (!fields) return;

    if (fields.success && fields.isValid) this.isValid = true;
    else if (fields.code === 401) this.isExpired = true;
    else if (fields.code === 409) this.isUsed = true;
    else if (fields.code === 400 || fields.code === 403) {
      this.isInvalid = true;
    }
  }
}
